import React from 'react';
import TabDescription from '../../../components/report/TabDescription';

export default (issues, descriptionText) => (
  <TabDescription
    count={issues && issues.length > 0 ? issues.length : null}
    descriptionText={descriptionText}
  />
);
